/* unplugin-vue-components disabled */import script from "./ScrollPane.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollPane.vue?vue&type=script&setup=true&lang=js"

import "./ScrollPane.vue?vue&type=style&index=0&id=731d2c91&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-731d2c91"]])

export default __exports__